import React, { useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8002/api/v1';

const ROLES = [
  {
    id: 'customer',
    label: 'عميل',
    sub: 'اطلب المياه لمنزلك أو مشروعك',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
      </svg>
    ),
    color: 'from-blue-500 to-cyan-500',
    bg: 'bg-blue-50 border-blue-200 hover:border-blue-400',
    selected: 'bg-blue-500 border-blue-500 text-white',
  },
  {
    id: 'driver',
    label: 'سائق',
    sub: 'وصّل الطلبات واكسب من عملك',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
      </svg>
    ),
    color: 'from-emerald-500 to-teal-500',
    bg: 'bg-emerald-50 border-emerald-200 hover:border-emerald-400',
    selected: 'bg-emerald-500 border-emerald-500 text-white',
  },
  {
    id: 'tenant',
    label: 'شركة مياه',
    sub: 'أدر طلبات التوصيل وفريقك',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
      </svg>
    ),
    color: 'from-violet-500 to-purple-500',
    bg: 'bg-violet-50 border-violet-200 hover:border-violet-400',
    selected: 'bg-violet-500 border-violet-500 text-white',
  },
];

export default function LoginPage() {
  const [role, setRole]       = useState(null);
  const [step, setStep]       = useState('role'); // role | form | identify
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  // Customer & Tenant fields
  const [phone,    setPhone]    = useState('');
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPw,   setShowPw]   = useState(false);

  // Driver identify step
  const [identifier,  setIdentifier]  = useState('');
  const [driverInfo,  setDriverInfo]  = useState(null);
  const [driverStep,  setDriverStep]  = useState('identify'); // identify | password | setpw
  const [nationalId,  setNationalId]  = useState('');

  const selectRole = (r) => {
    if (r === 'customer') { window.location.href = '/customer/login'; return; }
    setRole(r); setStep('form'); setError('');
  };

  const loginCustomer = async () => {
    const data = await fetch(`${API}/customer/auth/login`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: phone.trim(), password }),
    }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail || 'خطأ'); return d; });
    localStorage.setItem('watrly_customer_token', data.access_token);
    if (data.refresh_token) localStorage.setItem('watrly_customer_refresh_token', data.refresh_token);
    if (data.customer) localStorage.setItem('watrly_customer_data', JSON.stringify(data.customer));
    window.location.href = '/customer/home';
  };

  const identifyDriver = async () => {
    const data = await fetch(`${API}/driver/auth/identify`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identifier: identifier.trim() }),
    }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail || 'خطأ'); return d; });
    setDriverInfo(data);
    setDriverStep(data.has_password ? 'password' : 'setpw');
  };

  const loginDriver = async () => {
    const data = await fetch(`${API}/driver/auth/login`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identifier: identifier.trim(), password }),
    }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail || 'بيانات غير صحيحة'); return d; });
    localStorage.setItem('drv_token', data.access_token);
    if (data.refresh_token) localStorage.setItem('drv_refresh', data.refresh_token);
    window.location.href = '/driver/home';
  };

  const setPasswordDriver = async () => {
    const data = await fetch(`${API}/driver/auth/set-password`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identifier: identifier.trim(), national_id: nationalId.trim(), password }),
    }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail || 'خطأ'); return d; });
    localStorage.setItem('drv_token', data.access_token);
    if (data.refresh_token) localStorage.setItem('drv_refresh', data.refresh_token);
    window.location.href = '/driver/home';
  };

  const loginTenant = async () => {
    const data = await fetch(`${API}/tenant/auth/login`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.trim(), password }),
    }).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail || 'بيانات غير صحيحة'); return d; });
    localStorage.setItem('watrly_tenant_token', data.access_token);
    if (data.refresh_token) localStorage.setItem('watrly_tenant_refresh_token', data.refresh_token);
    window.location.href = '/tenant/dashboard';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      if (role === 'customer') await loginCustomer();
      else if (role === 'driver') {
        if (driverStep === 'identify') await identifyDriver();
        else if (driverStep === 'password') await loginDriver();
        else await setPasswordDriver();
      }
      else if (role === 'tenant') await loginTenant();
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const roleInfo = ROLES.find(r => r.id === role);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex items-center justify-center p-4" dir="rtl">
      <div className="w-full max-w-md">

        {/* Logo */}
        <div className="text-center mb-8">
          <a href="/" className="inline-flex flex-col items-center gap-2">
            <div className="w-14 h-14 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center">
              <svg className="w-8 h-8 text-cyan-400" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8z"/>
              </svg>
            </div>
            <span className="text-2xl font-bold text-white">وترلي</span>
          </a>
          <p className="text-white/50 text-sm mt-2">تسجيل الدخول إلى حسابك</p>
        </div>

        <div className="bg-white/[0.07] backdrop-blur-xl border border-white/10 rounded-3xl p-6 shadow-2xl">

          {/* ── Step 1: Role selector ── */}
          {step === 'role' && (
            <>
              <h2 className="text-xl font-bold text-white mb-2 text-center">أنت؟</h2>
              <p className="text-white/50 text-sm text-center mb-6">اختر نوع حسابك للمتابعة</p>
              <div className="space-y-3">
                {ROLES.map(r => (
                  <button key={r.id} onClick={() => selectRole(r.id)}
                    className="w-full flex items-center gap-4 p-4 rounded-2xl border-2 bg-white/5 border-white/10 hover:border-white/30 hover:bg-white/10 transition-all group text-right">
                    <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${r.color} flex items-center justify-center text-white flex-shrink-0`}>
                      {r.icon}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-white text-base">{r.label}</div>
                      <div className="text-white/50 text-sm mt-0.5">{r.sub}</div>
                    </div>
                    <svg className="w-5 h-5 text-white/30 group-hover:text-white/60 transition-colors flex-shrink-0 rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                ))}
              </div>
              <div className="mt-6 text-center">
                <span className="text-white/40 text-sm">ليس لديك حساب؟ </span>
                <a href="/register" className="text-cyan-400 text-sm font-semibold hover:underline">سجّل الآن</a>
              </div>
            </>
          )}

          {/* ── Step 2: Login form ── */}
          {step === 'form' && (
            <>
              {/* Role badge + back */}
              <div className="flex items-center gap-3 mb-6">
                <button onClick={() => { setStep('role'); setError(''); setDriverStep('identify'); setDriverInfo(null); }}
                  className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors flex-shrink-0">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                </button>
                <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full bg-gradient-to-r ${roleInfo?.color} bg-opacity-20`}>
                  <span className="text-white font-semibold text-sm">{roleInfo?.label}</span>
                </div>
              </div>

              <h2 className="text-xl font-bold text-white mb-5">
                {role === 'driver' && driverStep === 'identify' && 'مرحباً بك 👋'}
                {role === 'driver' && driverStep === 'password' && `أهلاً ${driverInfo?.full_name?.split(' ')[0]} 👋`}
                {role === 'driver' && driverStep === 'setpw'    && 'إنشاء كلمة مرور 🔐'}
                {role !== 'driver' && 'تسجيل الدخول'}
              </h2>

              {error && (
                <div className="mb-4 px-4 py-3 rounded-xl bg-red-500/20 border border-red-500/30 text-red-300 text-sm">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">

                {/* Customer */}
                {role === 'customer' && (
                  <>
                    <Field label="رقم الهاتف" value={phone} onChange={setPhone} type="tel" placeholder="05xxxxxxxx" dir="ltr" />
                    <PasswordField label="كلمة المرور" value={password} onChange={setPassword} show={showPw} onToggle={() => setShowPw(p=>!p)} />
                  </>
                )}

                {/* Driver - identify */}
                {role === 'driver' && driverStep === 'identify' && (
                  <Field label="رقم الجوال أو رقم الهوية" value={identifier} onChange={setIdentifier} type="text" placeholder="05XXXXXXXX أو 1XXXXXXXXX" dir="ltr" />
                )}

                {/* Driver - password */}
                {role === 'driver' && driverStep === 'password' && (
                  <PasswordField label="كلمة المرور" value={password} onChange={setPassword} show={showPw} onToggle={() => setShowPw(p=>!p)} />
                )}

                {/* Driver - set password */}
                {role === 'driver' && driverStep === 'setpw' && (
                  <>
                    <p className="text-white/60 text-sm">مرحباً {driverInfo?.full_name}! أنشئ كلمة مرور لحسابك</p>
                    <Field label="رقم الهوية الوطنية (للتحقق)" value={nationalId} onChange={setNationalId} type="text" placeholder="1XXXXXXXXX" dir="ltr" />
                    <PasswordField label="كلمة مرور جديدة (6 أحرف على الأقل)" value={password} onChange={setPassword} show={showPw} onToggle={() => setShowPw(p=>!p)} />
                  </>
                )}

                {/* Tenant */}
                {role === 'tenant' && (
                  <>
                    <Field label="البريد الإلكتروني" value={email} onChange={setEmail} type="email" placeholder="example@company.com" dir="ltr" />
                    <PasswordField label="كلمة المرور" value={password} onChange={setPassword} show={showPw} onToggle={() => setShowPw(p=>!p)} />
                  </>
                )}

                <button type="submit" disabled={loading}
                  className={`w-full py-3.5 rounded-2xl font-bold text-white text-base bg-gradient-to-r ${roleInfo?.color} hover:opacity-90 active:scale-[0.98] transition-all shadow-lg disabled:opacity-50 flex items-center justify-center gap-2`}>
                  {loading
                    ? <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    : role === 'driver' && driverStep === 'identify' ? 'متابعة ←'
                    : role === 'driver' && driverStep === 'setpw'    ? 'حفظ وتسجيل الدخول'
                    : 'تسجيل الدخول'}
                </button>
              </form>

              {/* Back for driver password step */}
              {role === 'driver' && driverStep !== 'identify' && (
                <button onClick={() => { setDriverStep('identify'); setDriverInfo(null); setError(''); }}
                  className="mt-3 w-full text-center text-white/40 text-sm hover:text-white/60 transition-colors">
                  ← تغيير الرقم
                </button>
              )}

              <div className="mt-5 text-center">
                <span className="text-white/40 text-sm">ليس لديك حساب؟ </span>
                <a href="/register" className="text-cyan-400 text-sm font-semibold hover:underline">سجّل الآن</a>
              </div>
            </>
          )}
        </div>

        <p className="text-center text-white/20 text-xs mt-6">© {new Date().getFullYear()} وترلي — جميع الحقوق محفوظة</p>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = 'text', placeholder, dir }) {
  return (
    <div>
      <label className="block text-sm font-medium text-white/70 mb-1.5">{label}</label>
      <input
        type={type} value={value} onChange={e => onChange(e.target.value)}
        placeholder={placeholder} dir={dir} required
        className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/30 transition-all text-sm"
      />
    </div>
  );
}

function PasswordField({ label, value, onChange, show, onToggle }) {
  return (
    <div>
      <label className="block text-sm font-medium text-white/70 mb-1.5">{label}</label>
      <div className="relative">
        <input
          type={show ? 'text' : 'password'} value={value} onChange={e => onChange(e.target.value)}
          placeholder="••••••••" required minLength={6}
          className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/30 transition-all text-sm"
        />
        <button type="button" onClick={onToggle}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70 transition-colors p-1">
          {show
            ? <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg>
            : <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
          }
        </button>
      </div>
    </div>
  );
}
